import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-logged-out',
  templateUrl: './logged-out.component.html',
  styleUrls: ['./logged-out.component.scss'],
  standalone: false,
})
export class LoggedOutComponent {
  constructor(private router: Router) {}

  /**
   * Navigate to home which is protected and will trigger login via MsalGuard
   */
  loginNow(): void {
    // Navigate to home - the MsalGuard on the route will handle authentication
    // This is the same behavior as clicking the home icon
    this.router.navigate(['/']);
  }
}
